import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { FaqsComponent } from './features/faqs/faqs.component';
import { ContactUsComponent } from './features/contact-us/contact-us.component';
import { SearchforstudentsComponent } from './features/searchforstudents/searchforstudents.component';
import { AdminComponent } from './features/admin/admin.component';
import { FailedComponent } from './features/failed/failed.component';
import { MsalGuard } from '@azure/msal-angular';
import { ReportsComponent } from './features/reports/reports.component';
import { ReportsStartComponent } from './features/reports/reports-start/reports-start.component';
import { ArchivedRostersComponent } from './features/reports/archived-rosters/archived-rosters.component';

const routes: Routes = [
  { path: '', component: HomeComponent,canActivate: [MsalGuard]},
  { path: 'failed', component: FailedComponent },
  { path: 'failed/:reason', component: FailedComponent },
  { path: 'home', component: HomeComponent,canActivate: [MsalGuard] },
  { path: 'faqs', component: FaqsComponent  ,canActivate: [MsalGuard]},
  { path: 'contact-us', component: ContactUsComponent ,canActivate: [MsalGuard] },
  { path: 'search-for-students', component: SearchforstudentsComponent,canActivate: [MsalGuard] },
  { path: 'claims' , canActivate: [MsalGuard],loadChildren: () => import('./features/claims/claims.module').then(m => m.ClaimsModule) },
  { path: 'roster' ,canActivate: [MsalGuard],loadChildren: () => import('./features/Roster/roster.module').then(m => m.RosterModule) },
  { path: 'admin',component: AdminComponent ,canActivate: [MsalGuard]},
  {
    path: 'reports', component: ReportsComponent ,canActivate: [MsalGuard],
    children: [
      { path: '', component: ReportsStartComponent, canActivate: [MsalGuard] },
      { path: 'archived-rosters', component: ArchivedRostersComponent, canActivate: [MsalGuard] },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
